import styled from '@emotion/styled';

import { css } from '@emotion/react';
import {
    boxSizes,
    colors,
    fontSizes,
    fontWeights,
    gutterSizes,
    lineHeights,
} from '@gumtree/ui-library/src/base/theme';

export const StyledRangeFreeformFrame = styled.div`
    & input {
        width: 100%;
        height: 38px;
        border-radius: 4px;
        font-size: ${fontSizes.base};
        border-color: ${colors.bark40};
    }

    .field {
        margin-bottom: ${gutterSizes.medium10};
    }

    .form-element {
        .button {
            height: 100%;
        }

        &:focus-within {
            outline: 2px solid ${colors.gtallBlue};
            border-radius: ${boxSizes.borderRadius4};
        }
    }
`;

export const StyledBlockTitle = styled.div`
    font-size: ${fontSizes.base};
    font-weight: ${fontWeights.bold};
    line-height: ${lineHeights.base};
    margin-bottom: ${gutterSizes.base};
`;

export const updateButtonCss = (theme) => css`
    && {
        background-color: ${theme.palette.primary.main};
        border-radius: ${boxSizes.borderRadius4};
        color: ${theme.palette.primary.mainContrastText};
        font-weight: ${fontWeights.lightBold};
        font-size: ${fontSizes.base};
        line-height: ${lineHeights.base};

        padding: ${gutterSizes.base} 30px;
        width: 100%;
        justify-content: center;

        &:hover {
            background: ${theme.palette.primary.dark};
            color: ${theme.palette.primary.darkContrastText};
        }

        &:active {
            background: ${theme.palette.primary.main};
        }
    }
`;
